const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    cellphone: {
      type: 'string',
      title: 'شماره همراه'
    }
  }
});

export default schema;
